import type { Role } from '../types'

export function getAuthenticatedDestination(
  role: Role | null,
  attemptedDestination?: string,
  fallbackDestination = '/',
): string {
  if (
    (role === 'admin' || role === 'seller_agent') &&
    (attemptedDestination === undefined ||
      attemptedDestination === '/' ||
      attemptedDestination === '/dashboard')
  ) {
    return '/abonos'
  }

  return attemptedDestination ?? fallbackDestination
}
